<template>

  <b-row class="text-center bg-white mb-3 p-4 steps justify-content-center" style="margin:auto;">
    <b-col sm="4" md="4" lg="3" class="step-item d-flex text-center justify-content-around">
      <p class="mx-2">Carichi il tuo documento</p>
      <b-img src="/iconss/icona1.png" class="rounded-pill bg-primary text-center"></b-img>
      <img src="/img/arrow_gray.png" style="width: 3rem" />
    </b-col>
    <b-col sm="4" md="4" lg="3" class="step-item d-flex justify-content-around">
      <p class="mx-2">Si attiva la traduzione automatica</p>
      <b-img src="/iconss/icona2.png" class="rounded-pill bg-primary text-center"></b-img>
      <img src="/img/arrow_gray.png" style="width: 3rem" />
    </b-col>
    <b-col sm="4" md="4" lg="3" class="step-item d-flex justify-content-around">
      <p class="mx-2">La persona madrelingua corregge la traduzione</p>
      <b-img src="/iconss/icona3.png" class="rounded-pill bg-primary text-center"></b-img>
      <img src="/img/arrow_gray.png" style="width: 3rem" />
    </b-col>
    <b-col sm="4" md="4" lg="3" class="step-item d-flex justify-content-around">
      <p class="mx-2">Ricevi la tua traduzione</p>
      <b-img src="/iconss/icona4.png" class="rounded-pill bg-primary text-center"></b-img>
      <img src="/img/arrow_gray.png" style="width: 3rem; opacity: 0;" />
    </b-col>
  </b-row>

</template>

<script>
import util from "@/mixing/util";

export default {
  name: "HomeSteps",
  mixins: [util],
  methods: {},
};
</script>
<style scoped>
.steps .step-item {
  display: flex;
  vertical-align: middle !important;
}
.steps .step-item p {
  display: inline-block;
  min-width: 100px;
  max-width: 100px;
  font-weight: bolder;
  color: #757270;
  margin: auto 0.8rem;
}
@media (max-width: 768px) {
  .steps .step-item p {
    margin: 0 !important;
    padding: 0 !important;
  }
  .step-item img {
    width: 50px;
    height: 50px;
    margin: auto 0;
  }
}
</style>
